 export default function (scrollBar, direction = 1) {
  const left = scrollBar.scrollLeft + (scrollBar.clientWidth) * direction;
  const top = scrollBar.scrollTop + (scrollBar.clientHeight) * direction;

  scrollBar.scrollTo({
    left,
    top,
    behavior: 'smooth'
  });
}